(function() { window.GUID_de7f69de_d826_45ac_abf5_c5f3b99a893b = { getGuid: function() { return "de7f69de-d826-45ac-abf5-c5f3b99a893b"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class DivergingBarChart {
            constructor(params) {
                this.id = CS.Helper.generateRandomId();
                this.appElement = null;
                this.containerElement = null;
                this.innerChartElement = null;
                this.innerChartContainerElement = null;
                this.state = CS.Enumeration.ChartState.Unready;
                this.datapoints = [];
                this.svg = null;
                this.chartWidth = CS.CommonData.Current.IsMobileDevice ? 350 : 500;
                this.chartHeight = 0;
                this._barHeight = 40;
                this.barHeight = this._barHeight;
                this.marginTop = 1;
                this.marginRight = this._barHeight;
                this.marginBottom = 1;
                this.marginLeft = this._barHeight;
                this.barPadding = 0.1;
                this.fontFamily = `"Open Sans", sans-serif`;
                this.fontSize = 16;
                this.shouldStack = false;
                this.colors = [];
                this.seriesIds = [];
                if (params.id)
                    this.id = params.id;
                this.datapoints = params.datapoints;
                this.baseContainerElementId = params.containerElementId;
                this.colors = params.colors;
                if (params.absoluteMaxX != null)
                    this.absoluteMaxX = params.absoluteMaxX;
                this.setChartDimensions();
            }
            setChartDimensions() {
                this.chartHeight =
                    this.datapoints.length * this.barHeight +
                        this.marginTop +
                        this.marginBottom +
                        this.barPadding;
            }
            init() {
                return __awaiter(this, void 0, void 0, function* () {
                    yield this.initialize();
                });
            }
            initialize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.setState(CS.Enumeration.ChartState.Initializing);
                        this.createHTML();
                        yield this.load();
                        this.render()
                            .then(() => {
                            this.setState(CS.Enumeration.ChartState.Ready);
                        })
                            .catch((error) => {
                            console.error(error);
                            this.setState(CS.Enumeration.ChartState.Error);
                        });
                    }
                    catch (error) {
                        console.error(error);
                        this.setState(CS.Enumeration.ChartState.Error);
                    }
                });
            }
            createHTML() {
                this.appElement = document.body.querySelector(`#${this.baseContainerElementId}`);
                if (this.appElement == null) {
                    throw new Error("Container element not found.");
                }
                const containerHtml = `<div id="diverging-bar-chart-${this.id}" class="diverging-bar-chart chart"></div>`;
                const containerElementExists = document.body.querySelector(`#diverging-bar-chart-${this.id}`) != null;
                if (!containerElementExists) {
                    this.appElement.insertAdjacentHTML("beforeend", containerHtml);
                    this.containerElement = document.body.querySelector(`#diverging-bar-chart-${this.id}`);
                }
                if (this.containerElement == null) {
                    throw new Error("Container element not found.");
                }
                const innerChartContainerHtml = `<div class="diverging-bar-chart__chart-container chart-container" style="position: relative;"></div>`;
                const innerChartContainerElementExists = document.body.querySelector(`#diverging-bar-chart-${this.id} .diverging-bar-chart__chart-container`) != null;
                if (!innerChartContainerElementExists) {
                    this.containerElement.insertAdjacentHTML("beforeend", innerChartContainerHtml);
                    this.innerChartContainerElement = document.body.querySelector(`#diverging-bar-chart-${this.id} .diverging-bar-chart__chart-container`);
                }
                if (this.innerChartContainerElement == null) {
                    throw new Error("Inner chart container element not found.");
                }
                const innerChartHtml = `<div class="diverging-bar-chart__chart" style="position: relative;"></div>`;
                const innerChartElementExists = document.body.querySelector(`#diverging-bar-chart-${this.id} .diverging-bar-chart__chart`) != null;
                if (!innerChartElementExists) {
                    this.innerChartContainerElement.insertAdjacentHTML("beforeend", innerChartHtml);
                    this.innerChartElement = document.body.querySelector(`#diverging-bar-chart-${this.id} .diverging-bar-chart__chart`);
                }
                if (this.innerChartElement == null) {
                    throw new Error("Inner chart element not found.");
                }
            }
            load() {
                return __awaiter(this, void 0, void 0, function* () {
                    this.setChartDimensions();
                });
            }
            render() {
                return new Promise((resolve, reject) => {
                    try {
                        let extent = d3.extent(this.datapoints, (d) => d.value);
                        if (this.absoluteMaxX != null) {
                            extent = [this.absoluteMaxX * -1, this.absoluteMaxX];
                        }
                        this.xScale = d3
                            .scaleLinear()
                            .domain(extent)
                            .rangeRound([this.marginLeft, this.chartWidth - this.marginRight]);
                        this.yScale = d3
                            .scaleBand()
                            .domain(this.datapoints.map((d) => d.id))
                            .rangeRound([this.marginTop, this.chartHeight - this.marginBottom])
                            .padding(this.barPadding);
                        // Create the SVG container. 
                        this.svg = d3
                            .create("svg")
                            .attr("viewBox", [0, 0, this.chartWidth, this.chartHeight])
                            .attr("style", `max-width: 100%; height: auto; font-family: ${this.fontFamily}; font-size: ${this.fontSize}px;`);
                        // Add rects.
                        this.svg
                            .append("g")
                            .selectAll()
                            .data(this.datapoints)
                            .join("rect")
                            .attr("fill", (d) => {
                            return d.value > 0 ? this.colors[0] : this.colors[1];
                        })
                            .attr("x", (d) => this.xScale(Math.min(d.value, 0)))
                            .attr("y", (d) => this.yScale(d.id))
                            .attr("width", (d) => Math.abs(this.xScale(d.value) - this.xScale(0)))
                            .attr("height", this.yScale.bandwidth());
                        // Add text labels.
                        this.svg
                            .append("g")
                            .attr("font-family", this.fontFamily)
                            .attr("font-size", this.fontSize)
                            .selectAll()
                            .data(this.datapoints)
                            .join("text")
                            .attr("text-anchor", (d) => (d.value < 0 ? "end" : "start"))
                            .attr("x", (d) => this.xScale(d.value) + Math.sign(d.value - 0) * 4)
                            .attr("y", (d) => this.yScale(d.id) + this.yScale.bandwidth() / 2)
                            .attr("dy", "0.35em")
                            .attr("fill", (d) => {
                            return d.value > 0 ? this.colors[0] : this.colors[1];
                        })
                            .attr("font-weight", (d) => {
                            return d.value === 0 ? 400 : 700;
                        })
                            .text((d) => {
                            if (d.value === 0) {
                                return d.value;
                            }
                            else if (d.value > 0) {
                                return `+${d.value}`;
                            }
                            return d.value;
                        });
                        // Add the axes and grid lines.
                        // this.svg
                        //   .append("g")
                        //   .attr("transform", `translate(0,${this.marginTop})`)
                        //   .call(
                        //     d3
                        //       .axisTop(this.xScale)
                        //       .ticks(this.chartWidth / 80)
                        //       .tickFormat((d) => {
                        //         return d;
                        //       })
                        //   )
                        //   .call((g) =>
                        //     g
                        //       .selectAll(".tick line")
                        //       .clone()
                        //       .attr(
                        //         "y2",
                        //         this.chartHeight - this.marginTop - this.marginBottom
                        //       )
                        //       .attr("stroke-opacity", 0.1)
                        //   )
                        //   .call((g) => g.select(".domain").remove());
                        this.svg
                            .append("g")
                            .attr("transform", `translate(${this.xScale(0)},0)`)
                            .call(d3
                            .axisLeft(this.yScale)
                            .tickSize(0)
                            .tickPadding(6)
                            .tickFormat((d) => {
                            var _a;
                            const matchingDatapoint = this.datapoints.find((dp) => dp.id === d);
                            if (matchingDatapoint == null) {
                                return "";
                            }
                            return (_a = matchingDatapoint.secondaryLabel) !== null && _a !== void 0 ? _a : "";
                        }))
                            .call((g) => g
                            .attr("font-family", this.fontFamily)
                            .selectAll(".domain")
                            .attr("opacity", 0.5))
                            .call((g) => g
                            .attr("font-family", this.fontFamily)
                            .selectAll(".tick text")
                            .attr("opacity", 0.7)
                            .attr("font-size", this.fontSize)
                            .attr("font-weight", 400)
                            .attr("font-style", "italic")
                            .filter((d, i) => this.datapoints[i].value < 0)
                            .attr("text-anchor", "start")
                            .attr("x", 6));
                        const svgNode = this.svg.node();
                        if (!svgNode) {
                            return reject(new Error("SVG node not found."));
                        }
                        if (!this.innerChartElement) {
                            return reject(new Error("Chart element not found."));
                        }
                        if (!this.innerChartContainerElement) {
                            return reject(new Error("Chart container element not found."));
                        }
                        this.innerChartElement.appendChild(svgNode);
                    }
                    catch (error) {
                        return reject(error);
                    }
                });
            }
            setState(newState) {
                this.state = newState;
                this.updateUI();
            }
            updateUI() {
                switch (this.state) {
                    case CS.Enumeration.ChartState.Initializing:
                    case CS.Enumeration.ChartState.Unready:
                    case CS.Enumeration.ChartState.Ready:
                    case CS.Enumeration.ChartState.Destroying:
                    case CS.Enumeration.ChartState.Running:
                    case CS.Enumeration.ChartState.Stopping:
                    case CS.Enumeration.ChartState.Stopped:
                    case CS.Enumeration.ChartState.Error:
                    case CS.Enumeration.ChartState.Finished:
                    default:
                        break;
                }
            }
            destroy() {
                return new Promise((resolve, reject) => {
                    try {
                        this.setState(CS.Enumeration.ChartState.Destroying);
                        this.svg.remove();
                    }
                    catch (error) {
                        console.error(error);
                        this.setState(CS.Enumeration.ChartState.Error);
                        reject(error);
                    }
                });
            }
        }
        Controls.DivergingBarChart = DivergingBarChart;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=DivergingBarChart.js.map
